import React from "react";
import CompleteProfile from "../components/Auth/CompleteProfile";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";

const CompleteProfilePage = () => {
  return (
    <>
      <PublicHeader />
      <CompleteProfile />
      <Footer />
    </>
  );
};

export default CompleteProfilePage;
